<!-- =========================================================================================
  File Name: DataListListView.vue
  Description: Data List - List View
  ----------------------------------------------------------------------------------------
  Item Name: Vuesax Admin - VueJS Dashboard Admin Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div id="analyze-trend">
    <div
      class="vx-row"
      v-if="['SFM', 'SSM', 'FSM'].includes(artefact.type) && topUnits[type].seriesData &&  topUnits[type].seriesData.length > 0"
    >
      <!-- LINE CHART -->
      <div class="vx-col w-full mb-base">
        <vx-card
          :title="artefact.type === 'FSM' ? 'Category Performance' : (artefact.type === 'SFM' ? 'Top Selling '+ topUnits[type].label +' by Rate of Sale' : 'Slow selling '+ topUnits[type].label +' by Rate of Sale')"
          subtitle
        >
          <div slot="no-body" class="p-6 pb-0">
            <vue-apex-charts
              type="bar"
              height="310"
              :options="topUnits[type].chartOptions"
              :series="topUnits[type].seriesData"
            ></vue-apex-charts>
          </div>
        </vx-card>
      </div>

      <!-- TOP 5 CHART -->
      <!-- <div class="vx-col w-full md:w-1/3 mb-base">
        <vx-card :title="(artefact.type === 'SFM' ? 'Top Selling Skus' : 'Slow Movingh Skus')" subtitle>
            <div slot="no-body" class="p-6 pb-10">
              <vue-apex-charts type="donut" height="325" :options="topUnits.sku.chartOptions" :series="topUnits.sku.seriesData"></vue-apex-charts>
            </div>
        </vx-card>
      </div>-->
    </div>
    <div
      class="vx-row"
      v-if="['SST', 'CST', 'BST', 'CSST', 'BSST'].includes(artefact.type)"
    >
      <!-- LINE CHART -->
      <div class="vx-col w-full mb-base">
        <vx-card title="Sale Trend" subtitle="Sale Trend by Week">
          <div slot="no-body" class="p-6 pb-0">
            <vue-apex-charts
              type="line"
              height="355"
              :options="trendLine.chartOptions"
              :series="makeUnitStatsData()"
            />
          </div>
        </vx-card>
      </div>

      <!-- RADIAL CHART -->
      <!-- <div class="vx-col w-full md:w-1/3 mb-base"></div> -->
    </div>

  </div>
</template>

<script>
import { mapGetters } from "vuex";
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import VueApexCharts from "vue-apexcharts";

import appConfig from "@/../appConfig.js";

const themeColors = appConfig.chart.colors;

export default {
  props: {
    artefact: { type: Object, required: true },
    type: { type: String, required: true }
  },
  components: {
    VueApexCharts,
    VuePerfectScrollbar
  },
  data() {
    return {
      units: {
        category: {
          headers: [],
          data: []
        },
        sku: {
          headers: [],
          data: []
        }
      },
      topUnits: {
        count: 50,
        category: {
          label: "Categories",
          chartOptions: {},
          seriesData: []
        },
        sku: {
          label: "Skus",
          chartOptions: {},
          seriesData: []
        }
      },
      trendDonut: {
        series: [],
        chartOptions: {
          labels: [],
          colors: themeColors,
          responsive: [
            {
              breakpoint: 480,
              options: {
                chart: {
                  width: 200
                },
                legend: {
                  position: "bottom"
                }
              }
            }
          ],
          legend: {
            show: false
          }
        }
      },
      trendBar: {
        series: [
          {
            name: "",
            data: []
          }
        ],
        chartOptions: {
          colors: themeColors,
          chart: {
            toolbar: {
              show: false
            },
            dropShadow: {
              enabled: true,
              top: 20,
              left: 2,
              blur: 6,
              opacity: 0.2
            }
          },
          plotOptions: {
            bar: {
              horizontal: false,
              endingShape: "rounded",
              columnWidth: "35%"
            }
          },
          dataLabels: {
            enabled: false
          },
          stroke: {
            curve: "smooth",
            dashArray: [0, 8],
            width: [2, 2]
          },
          xaxis: {
            labels: {
              show: false,
              style: {
                cssClass: "text-grey fill-current"
              }
            },
            axisTicks: {
              show: false
            },
            axisBorder: {
              show: false
            },
            title: {
              text: this.type === 'category' ? "Categories" : "Skus",
              rotate: 90,
              offsetY: 0,
              offsetX: 0,
              style: { fontSize: "11px", cssClass: "" }
            }
            // categories: []
          },
          yaxis: {
            title: {
              text: "Rate of Sale ( Units / Day )"
            }
          },
          fill: {
            opacity: 1
          },
          tooltip: {
            y: {
              // formatter: function(val) {
              //   return "$ " + val + " thousands"
              // }
            }
          }
        }
      },
      trendLine: {
        series: [
          {
            name: "",
            data: []
          }
        ],
        chartOptions: {
          chart: {
            type: "area",
            toolbar: { show: true },
            dropShadow: {
              enabled: true,
              top: 20,
              left: 2,
              blur: 6,
              opacity: 0.2
            }
          },
          stroke: {
            curve: "smooth",
            dashArray: [0, 8],
            width: [2, 2]
          },
          grid: {
            borderColor: "#e7e7e7"
          },
          legend: {
            show: false
          },
          colors: themeColors,
          fill: {
            type: "gradient",
            gradient: {
              shade: "dark",
              inverseColors: false,
              gradientToColors: themeColors,
              shadeIntensity: 1,
              type: "horizontal",
              opacityFrom: 1,
              opacityTo: 1,
              stops: [0, 100, 100, 100]
            }
          },
          markers: {
            size: 0,
            hover: {
              size: 5
            }
          },
          xaxis: {
            type: "datetime",
            tickAmount: 15,
            title: {
              text: "Week"
            },
            labels: {
              hideOverlappingLabels: true,
              // datetimeFormatter: {
              //   year: 'yyyy',
              //   month: 'MMM \'yy',
              //   day: 'dd MMM',
              //   hour: 'HH:mm'
              // },
              style: {
                cssClass: "text-grey fill-current"
              }
            },
            axisTicks: {
              show: false
            },
            // categories: ["Jan '18", "Feb '18", "Mar '18", "Apr '18", "May '18", "Jun '18", "Jul '18", "Aug '18", "Sep '18", "Oct '18", "Nov '18", "Dec '18", "Jan '19", "Feb '19", "Mar '19", "Apr '19", "May '19"],
            // categories: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec", "Jan", "Feb", "Mar", "Apr", "May"],
            // categories: ["Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec", "Jan"],
            // categories:[],
            axisBorder: {
              show: false
            }
          },
          yaxis: {
            tickAmount: 5,
            title: {
              text: this.artefact.mode === 'revenue' ? "Revenue ( "+this.$options.filters.currencySymbol('')+" )" : "Quantity",
              rotate: 90,
              offsetY: 0,
              offsetX: 0,
              style: { fontSize: "11px", cssClass: "" }
            },
            labels: {
              style: {
                cssClass: "text-grey fill-current"
              },
              formatter: function(val) {
                return val > 999
                  ? (val / 1000).toFixed(1) + "k"
                  : Math.round(val * Math.pow(10, 1)) / Math.pow(10, 1);
              }
            }
          },
          tooltip: {
            shared: true,
            intersect: false
            // x: { show: false }
          }
        }
      }
    }
  },
  computed: {
    // ...mapGetters({ items: "analyze/artefactUnit" })
  },
  methods: {
    fetchUnits(type, chartType) {
      this.units[type].data = this.formatItemsData(type);
      this.topUnits[type].chartOptions = this.chartOptions(type, chartType);
      this.topUnits[type].seriesData = this.seriesData(type, chartType);
    },
    formatItemsData(type) {
      let units = this.filterAndSortData(
        this.artefact.type,
        // this.items.res.order[type]
        this.artefact.res.trend[type]
      );
      if (this.artefact.type === "SFM" || this.artefact.type === 'FSM') {
        return units.reverse();
      } else {
        return units;
      }
    },
    filterAndSortData(rtype, data) {
      let filteredData = data.filter(t =>
      (rtype === 'SFM' && t.type === 'fast') || (rtype === 'SSM' && t.type === 'slow') || rtype === 'FSM'
      );
      
      return filteredData.sort(function(t1, t2) {
        var upd1 = t1.quantity;
        var upd2 = t2.quantity;

        if (upd1 < upd2) {
          return -1;
        }
        if (upd1 > upd2) {
          return 1;
        }

        // tags must be equal
        return 0;
      });
    }, 
    chartOptions(type, chartType) {
      // let unitsData = this.units[type].data.slice(0, this.topUnits.count);
      let unitsData = this.units[type].data;
      let typeData = [];

      for (let i = 0; i < unitsData.length; i++) {
        if(type === "sku") {
          typeData.push(unitsData[i].sku_id + ' - ' +unitsData[i].desc);
        } else if(!typeData.includes(unitsData[i].cat_1)) {
          typeData.push(unitsData[i].cat_1);
        }

        if(this.topUnits.count < typeData.length) break;
      }

      if (chartType === "bar") {
        this.trendBar.chartOptions.xaxis.categories = typeData;
        return this.trendBar.chartOptions;
      } else if (chartType === "donut") {
        this.trendDonut.chartOptions.labels = typeData;
        return this.trendDonut.chartOptions;
      }
    },
    seriesData(type, chartType) {
      let unitsData = this.units[type].data.slice(0, this.topUnits.count);
      let seriesData = [
        {
          name:
            this.artefact.type === "FSM" ? "Categories by Rate of Sale" : (this.artefact.type === "SFM"
              ? "Top Selling Categories"
              : "Slow Moving Categories"),
          data: []
        }
      ];

      for (let i = 0; i < unitsData.length; i++) {
        if (chartType === "bar") {
          seriesData[0].data.push(Number(unitsData[i].quantity));
        } else if (chartType === "donut") {
          seriesData[0].data.push(Number(unitsData[i].quantity));
        }
      }

      return seriesData;
    },

    makeUnitStatsData() {
      let series = [];
      let chartData = {};
      chartData = Object.assign(chartData, this.trendLine);

      for (let i = 0; i < this.artefact.tags.length; i++) {
        if(this.artefact.type && this.artefact.type.startsWith(this.artefact.tags[i].type)) {
          let filteredUnitDataTrend = {
            name: "",
            data: []
          };

          filteredUnitDataTrend.name = this.artefact.tags[i].tag;

          let filterAndSortData = this.filterAndSortDataForLine(
            this.artefact.tags[i],
            this.artefact.res.trend
          );

          let groupedUnit = this.buildPlotData(
            filterAndSortData
          );

          // filteredUnitDataTrend.data = groupedUnit;

          let maxWeeks = filterAndSortData.length;

          filteredUnitDataTrend.data = this.buildseriesOfGroup(this.artefact.mode, maxWeeks, filterAndSortData);

          series.push(filteredUnitDataTrend);

          // chartData.xaxis.categories = this.buildCategoryData(filterAndSortData, 'sale_trend');
        }
      }

      chartData.series = series;
      // chartData.xaxis.categories = this.buildCategoryData(filterAndSortData, 'sale_trend');
      // return chartData;
      return series;
    },
    filterAndSortDataForLine(tag, data) {
      let filteredData = data.filter(t =>
        t.store_code
          ? tag.code === t.store_code
          : ((tag.tag === t.product_category) || (tag.tag === t.brand))
      );

      return filteredData.sort(function(t1, t2) {
        var year1 = t1.sale_year;
        var year2 = t2.sale_year;

        var week1 = t1.sale_week;
        var week2 = t2.sale_week;

        if (year1 < year2 && week1 < week2) {
          return -1;
        }
        if (year1 > year2 && week1 > week2) {
          return 1;
        }

        // tags must be equal
        return 0;
      });
    },
    buildPlotData(data) {
      let plot = [];
      if (data) {
        for (let i = 0; i < data.length; i++) {
          if (data[i].type && data[i].type === "sale_trend") {
            plot.push(data[i].quantity);
          } else if (!data[i].type) {
            plot.push(data[i].quantity);
          }
        }
      }

      return plot;
    },
    buildCategoryData(data) {
      let plotCat = [];
      if (data) {
        for (let i = 0; i < data.length; i++) {
          if (data[i].type && data[i].type === "sale_trend") {
            plotCat.push(data[i].quantity);
          } else if (!data[i].type) {
            plotCat.push(data[i].quantity);
          }
        }
      }

      return plotCat;
    },

    buildseriesOfGroup(type, maxWeeks, groupedUnit) {
      console.log('buildseriesOfGroup > type', type);
      let series = [];
      let weekIndex = 0;
      let currentWeek = Number(groupedUnit[0].sale_week || 1);
      let currentMonth = Number(groupedUnit[0].sale_month || 0) - 1;
      let currentYear = groupedUnit[0].sale_year.toString().slice(2);
      let prevWeek = 100;

      while (weekIndex < maxWeeks) {
        if (groupedUnit[weekIndex]) {
          currentWeek = Number(groupedUnit[weekIndex].sale_week || 1);
          currentMonth = Number(groupedUnit[weekIndex].sale_month || 0);
          currentYear = groupedUnit[weekIndex].sale_year.toString().slice(2);

          //   let x = "w" + currentWeek + (prevWeek > currentWeek ? " '" + currentYear : "");
          let x = this.$moment()
            .isoWeekYear(currentYear)
            .isoWeek(currentWeek+1)
            .startOf('isoWeek')
            .format('MM-DD-YYYY');

          // let x =
          //   "w" +
          //   currentWeek +
          //   (prevWeek > currentWeek ? " '" + currentYear : "");  
          let y = groupedUnit[weekIndex][type]
            ? groupedUnit[weekIndex][type] : 0;

          series.push({
            x: x,
            y: this.$options.filters.numFormat(y, '0.00')
          });
        } else {
          let x = this.$moment()
            .isoWeekYear(currentWeek === 1 ? ++currentYear : currentYear)
            .isoWeek(currentWeek+1)
            .startOf('isoWeek')
            .format('MM-DD-YYYY');

          // let x =
          //   "w" +
          //   currentWeek +
          //   (prevWeek > currentWeek ? " '" + ++currentYear : "");
          let y = "0.00";

          currentWeek = currentWeek + 1;

          series.push({
            x: x,
            y: y
          });
        }

        prevWeek = currentWeek;
        weekIndex++;
      }
      return series;
    },
    showTitle() {
      
    }
  },
  created() {},
  mounted() {
    if(['SFM', 'SSM', 'FSM'].includes(this.artefact.type)) {
      this.fetchUnits(this.type, "bar");
    } else if(['SST', 'CST', 'BST', 'CSST', 'BSST'].includes(this.artefact.type)) {
      this.makeUnitStatsData();
    }
  }
};
</script>

<style lang="scss">
#analyze-trend {
  .reportrange-text {
    background: transparent;
    cursor: pointer;
    padding: 0px;
    border: 0px;
  }
}
#data-list-list-view {
  .vs-con-table {
    .vs-table--header {
      display: flex;
      flex-wrap: wrap-reverse;
      margin-left: 1.5rem;
      margin-right: 1.5rem;
      > span {
        display: flex;
        flex-grow: 1;
      }

      .vs-table--search {
        padding-top: 0;

        .vs-table--search-input {
          padding: 0.9rem 2.5rem;
          font-size: 1rem;

          & + i {
            left: 1rem;
          }

          &:focus + i {
            left: 1rem;
          }
        }
      }
    }

    .vs-table {
      border-collapse: separate;
      // border-spacing: 0 1.3rem;
      padding: 0 1rem;

      tr {
        box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.05);
        td {
          padding: 20px;
          &:first-child {
            border-top-left-radius: 0.5rem;
            border-bottom-left-radius: 0.5rem;
          }
          &:last-child {
            border-top-right-radius: 0.5rem;
            border-bottom-right-radius: 0.5rem;
          }
        }
        td.td-check {
          padding: 20px !important;
        }
      }
    }

    .vs-table--thead {
      th {
        padding-top: 0;
        padding-bottom: 0;

        .vs-table-text {
          text-transform: uppercase;
          font-weight: 600;
        }
      }
      th.td-check {
        padding: 0 15px !important;
      }
      tr {
        background: none;
        box-shadow: none;
      }
    }

    .vs-table--pagination {
      justify-content: center;
    }
  }
}

.chat-card-log {
  height: 400px;

  .chat-sent-msg {
    background-color: #f2f4f7 !important;
  }
}
</style>
